/* eslint-disable */
/// <reference path="acon.se.js" />
/* eslint-enable */

if (!window.console) {
	window.console = {
		log: function () { }
	}
}

(function ($, console) {
	var didScroll = false

	$.expr[':'].external = function (obj) {
		return !obj.href.match(/^mailto:/) && (obj.hostname !== window.location.hostname)
	}

	// cookie consent
	var cookieConsent = function (e) {
		e.preventDefault()
		document.cookie = 'cookieConsent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
		js('cookie-consent').remove()
	}

	// set navbar class on scroll
	var siteNavbarOnScroll = function () {
		var scrollValue = $(window).scrollTop()
		if (scrollValue > 0) {
			js('site-navbar').addClass('is-sticky')
		} else {
			js('site-navbar').removeClass('is-sticky')
		}

		didScroll = true
	}

	// init forms from Apsis Lead
	var initApsisLeadForms = function () {
		$('[data-apsis-form]').each(function (i, item) {
			var form = new window.ApsisLead.FormbuilderInstance()
			form.init({
				formId: $(item).data('apsis-form')
			})
		})
	}

	var bindEvents = function () {
		// cookie consent
		js('accept-cookies').on('click', cookieConsent)

		js('show-all-services').on('click', function () {
			$(this).fadeOut('30')
		})

		// share button
		js('facebook-share-btn').on('click', function () {
			var elem = $(this)

			window.FB.ui({
				method: 'share',
				display: 'popup',
				href: elem.data('url')
			}, function (response) { })

			return false
		})

		// on scroll event handler
		$(window).on('scroll', siteNavbarOnScroll)

		setInterval(function () {
			if (didScroll) {
				didScroll = false
			}
		}, 100)
	}

	var init = function () {
		// eslint-disable-next-line no-console
		console.log('Initializing acon.se...')
		bindEvents()
		initApsisLeadForms()
		// show cookie consent if no accepted

		if (document.cookie.match(/cookieConsent=[^;]+(.*)?$/) === null) {
			js('cookie-consent').addClass('is-visible')
		}
	}

	// fetch element from data-js param
	var js = function (name, ctx) {
		if (!ctx) {
			ctx = document
		}

		return $('[data-js~="' + name + '"]', ctx)
	}

	/* var jsClosest = function (name, ctx) {
		if (!ctx) {
			ctx = document
		}
		return $(ctx).closest('[data-js~="' + name + '"]')
	} */

	// Load CSS asynchronously when above the fold css is in use
	window.loadCSS('/css/acon.se.min.css')

	$(document).ready(init)
})(window.jQuery, window.console)

/* eslint-disable */
var MTIProjectId = '96546ccf-47a7-4876-9e4d-42252e96c188';

(function () {
	var mtiTracking = document.createElement('script');
	mtiTracking.type = 'text/javascript';
	mtiTracking.async = 'true';
	mtiTracking.src = '/fonts/mtiFontTrackingCode.js';

	(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mtiTracking);
})();


window.fbAsyncInit = function () {
	FB.init({
		appId: '587276751464821', status: true, cookie: true, xfbml: true
	});
};
(function (d, debug) {
	var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
	if (d.getElementById(id)) { return; }
	js = d.createElement('script'); js.id = id;
	js.async = true; js.src = "//connect.facebook.net/en_US/all" + (debug ? "/debug" : "") + ".js";
	ref.parentNode.insertBefore(js, ref);
}(document, /*debug*/ false)); /* switch to false on publish */

/* eslint-enable */
